import { APP_INITIALIZER, NgModule } from '@angular/core'
import { CurrencyPipe, DatePipe } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'

import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'

import { EffectsModule } from '@ngrx/effects'
import { StoreModule } from '@ngrx/store'
import { SharedModule } from '@shared/shared.module'
import { AppRoutingModule } from './app-routing.module'
import { AppComponent } from './app.component'
import { ErrorModule } from './error/error.module'
import { NavService } from './nav.service'
import { AuthInterceptor } from './shared/interceptors/auth.interceptor'
import { AuthService } from './auth.service'
import { reducers, metaReducers } from './core/store'
import { LegacyEffects } from './core/store/legacy/legacy.effects'

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    SharedModule,
    AppRoutingModule,
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([LegacyEffects]),
    ErrorModule,
  ],
  providers: [
    CurrencyPipe,
    DatePipe,
    NavService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    {
      provide: APP_INITIALIZER,
      useFactory: (auth: AuthService) => () => auth.initOnAppStart(),
      deps: [AuthService],
      multi: true,
    },
  ],
})
export class AppModule {}
